module.exports = __webpack_public_path__ + "img/404.f4b274f3.png";